const PREFIX = 'sahal_cache_';
const TTL_MS = 30 * 60 * 1000;

const toPlain = (value) => {
  if (value == null) return value;
  if (typeof value.toDate === 'function') {
    return value.toDate().toISOString();
  }
  if (
    typeof value === 'object' &&
    typeof value.seconds === 'number' &&
    'nanoseconds' in value
  ) {
    return new Date(value.seconds * 1000).toISOString();
  }
  if (Array.isArray(value)) return value.map(toPlain);
  if (typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, nested]) => [key, toPlain(nested)])
    );
  }
  return value;
};

export const readCache = (key) => {
  try {
    const raw = sessionStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || Date.now() - parsed.ts > TTL_MS) {
      sessionStorage.removeItem(PREFIX + key);
      return null;
    }
    return parsed.data;
  } catch {
    return null;
  }
};

export const writeCache = (key, data) => {
  try {
    sessionStorage.setItem(
      PREFIX + key,
      JSON.stringify({ data: toPlain(data), ts: Date.now() })
    );
  } catch {
    // Ignore quota / private-mode failures
  }
};

export const clearCache = (key) => {
  try {
    sessionStorage.removeItem(PREFIX + key);
  } catch {
    // ignore
  }
};

export const clearAllCache = () => {
  try {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith(PREFIX))
      .forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // ignore
  }
};
